import React from "react";
import { Heading, T } from "../components/helpful";
import { Button } from "primereact/button";
import { Navigate } from "react-router-dom";
import img_1 from "../assets/img/image-1.jpg";

export default class Post extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      pageTitle: "titre du post",
      hotelImg: 0,
      desc: "date du post",
      return: false,
    };

    this.handleBack = this.handleBack.bind(this);
  }
  handleBack = () => {
    this.setState({ return: true });
  };

  subHeading = () => {
    return <>{this.state.desc}</>;
  }
  render() {
    return (
      <div>
        {this.state.return && <Navigate to="/blog" replace={true} />}
        <div className="">
          <div>
            <Heading heading={this.state.pageTitle} Desc={this.subHeading} />
          </div>

          <div className="main-content">
            <div className=" mb-4 ">
              <Button
                icon="pi pi-arrow-left"
                label="Back"
                severity="secondary"
                text
                className="text-white"
                onClick={this.handleBack}
              />
            </div>
            <div className="row">
              <img src={img_1} alt="" />
              <div className="py-4">
                <p className="py-2 lead">
                  Orientis vero limes in longum protentus et rectum ab Euphratis
                  fluminis ripis ad usque supercilia porrigitur Nili, laeva
                  Saracenis conterminans gentibus, dextra pelagi fragoribus
                  patens, quam plagam Nicator Seleucus occupatam auxit magnum in
                  modum, cum post Alexandri Macedonis obitum successorio iure
                  teneret regna Persidis, efficaciae inpetrabilis rex, ut
                  indicat cognomentum.
                </p>

                <p>
                  Quod cum ita sit, paucae domus studiorum seriis cultibus antea
                  celebratae nunc ludibriis ignaviae torpentis exundant, vocali
                  sonu, perflabili tinnitu fidium resultantes. denique pro
                  philosopho cantor et in locum oratoris doctor artium
                  ludicrarum accitur et bybliothecis sepulcrorum ritu in
                  perpetuum clausis organa fabricantur hydraulica, et lyrae ad
                  speciem carpentorum ingentes tibiaeque et histrionici gestus
                  instrumenta non levia.
                </p>
                <p className="py-2">
                  Orientis vero limes in longum protentus et rectum ab Euphratis
                  fluminis ripis ad usque supercilia porrigitur Nili, laeva
                  Saracenis conterminans gentibus, dextra pelagi fragoribus
                  patens, quam plagam Nicator Seleucus occupatam auxit magnum in
                  modum, cum post Alexandri Macedonis obitum successorio iure
                  teneret regna Persidis, efficaciae inpetrabilis rex, ut
                  indicat cognomentum.
                </p>
                <p>
                  Quod cum ita sit, paucae domus studiorum seriis cultibus antea
                  celebratae nunc ludibriis ignaviae torpentis exundant, vocali
                  sonu, perflabili tinnitu fidium resultantes. denique pro
                  philosopho cantor et in locum oratoris doctor artium
                  ludicrarum accitur et bybliothecis sepulcrorum ritu in
                  perpetuum clausis organa fabricantur hydraulica, et lyrae ad
                  speciem carpentorum ingentes tibiaeque et histrionici gestus
                  instrumenta non levia.
                </p>
              </div>
              <div className="">
                <span className="h6 ">Share: </span>
                <div className="d-flex fs-6 my-3 text-muted">
                  <i className=" mx-2 bi bi-twitter-x "></i>
                  <i className=" mx-2 bi bi-linkedin "></i>
                  <i className="  bi bi-facebook "></i>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}
